import angular from 'angular';
import utils from '@/shared/utils/adminpulse';

angular
  .module('cxSettings')
  .controller('ExportTaskTemplateSnippetDialogCtrl', [
    'flySvc',
    'translateListFilter',
    'FileSaver',
    '$element',
    'close',
    'appUrls',
    '$http',
    'taskTemplate',
    exportTaskTemplateSnippetDialogCtrl,
  ]);

function exportTaskTemplateSnippetDialogCtrl(
  flySvc,
  translateListFilter,
  FileSaver,
  $element,
  close,
  appUrls,
  $http,
  taskTemplate,
) {
  var vm = this;
  vm.taskTemplate = taskTemplate;
  vm.hasMails = taskTemplate.children.some(
    x => (x.type === 3 || x.type === 4) && !!x.mailTemplateId,
  );
  vm.hasParameters = taskTemplate.parameterCount > 0;
  vm.hasPeriodicities = taskTemplate.periodicityCount > 0;
  vm.saving = false;
  vm.showValidation = false;

  vm.model = {
    taskTemplateId: taskTemplate.id,
    name: translateListFilter(taskTemplate.id, 'tasktemplate', taskTemplate.name),
    exportMails: vm.hasMails,
    exportPeriodicities: vm.hasPeriodicities,
    exportParameters: vm.hasParameters,
    exportWorkflows: true,
  };

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };
  vm.isValid = function() {
    if (!vm.model.name) return false;

    return true;
  };
  const showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = utils.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      console.error(ex);
      //Parsing error?
      flySvc.error();
    }
  };
  vm.save = function() {
    if (vm.saving) return;
    if (!vm.isValid()) return;

    vm.saving = true;
    return $http
      .post(appUrls.api + '/api/Snippet/Export/TaskTemplate', vm.model, {
        responseType: 'arraybuffer',
      })
      .then(
        result => {
          const contentDisposition = result.headers('Content-Disposition');
          const filename = utils.getFileNameFromHeader(contentDisposition);
          var fileType = result.headers('Content-Type');

          var blob = new Blob([result.data], { type: 'application/json' });
          if (blob) {
            FileSaver.saveAs(blob, filename);
            $element.modal('hide');
            flySvc.success('msgConfirmChange');
            close(true, 500);
            vm.saving = false;
          }
        },
        error => {
          showArrayBufferError(error);
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
